import styled, { css } from 'styled-components';

const LinkText = styled.span`
  a {
    text-decoration: none;
    color: #0087c1 !important;
    cursor: pointer;
    ${({ styled }) =>
      styled &&
      css`
        color: #282b32;
      `}
  }
  span {
    font-size: 12px;
  }
`;

export default LinkText;
